import "./button";
import "./heading";
import "./icon";
import "./pagination";
import "./image";
import "./text";
